import { z } from 'zod';

/** Consumer-safe fiscal document (NF) row — no apuração, movements, raw XML or storage URI. */
export const ConsumerFiscalDocumentListItemSchema = z.object({
  id: z.uuid(),
  tenantId: z.uuid(),
  workshopName: z.string().min(1),
  placeId: z.uuid(),
  documentKind: z.string().min(1),
  series: z.string(),
  number: z.string(),
  authorizedAt: z.string().min(1),
  netTotalCents: z.string().min(1),
  currency: z.string().min(1),
});
export type ConsumerFiscalDocumentListItem = z.infer<typeof ConsumerFiscalDocumentListItemSchema>;

export const ConsumerFiscalDocumentsResponseSchema = z.object({
  items: z.array(ConsumerFiscalDocumentListItemSchema),
});
export type ConsumerFiscalDocumentsResponse = z.infer<typeof ConsumerFiscalDocumentsResponseSchema>;

export const ConsumerFiscalDocumentDetailSchema = ConsumerFiscalDocumentListItemSchema.extend({
  issuedAt: z.string().nullable(),
  /** Last 6 digits of the access key, or null when policy denies it. */
  accessKeyMasked: z.string().nullable(),
});
export type ConsumerFiscalDocumentDetail = z.infer<typeof ConsumerFiscalDocumentDetailSchema>;

export const ConsumerFiscalArtifactUrlSchema = z.object({
  downloadUrl: z.string().min(1),
  expiresAt: z.string().min(1),
  contentType: z.string().min(1),
  disposition: z.enum(['inline', 'attachment']),
});
export type ConsumerFiscalArtifactUrl = z.infer<typeof ConsumerFiscalArtifactUrlSchema>;
